var items = {
  "block.minecraft.air": "ayr",
  "block.minecraft.stone": "men",
  "block.minecraft.granite": "growan",
  "block.minecraft.polished_granite": "growan polsys",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "diorit bolsys",
  "block.minecraft.andesite": "andesit",
  "block.minecraft.polished_andesite": "andesit bolsys",
  "block.minecraft.grass_block": "stock gwels",
  "block.minecraft.dirt": "dor",
  "block.minecraft.coarse_dirt": "dor garow",
  "block.minecraft.podzol": "podsol",
  "block.minecraft.crimson_nylium": "nylium kogh",
  "block.minecraft.warped_nylium": "nylium koynt",
  "block.minecraft.cobblestone": "men kauns",
  "block.minecraft.oak_planks": "estyl dar",
  "block.minecraft.spruce_planks": "estyl sprus",
  "block.minecraft.birch_planks": "estyl besow",
  "block.minecraft.jungle_planks": "estyl gwylgos",
  "block.minecraft.acacia_planks": "estyl akasia",
  "block.minecraft.dark_oak_planks": "estyl dhar tewal",
  "block.minecraft.crimson_planks": "estyl kogh",
  "block.minecraft.warped_planks": "estyl koynt",
  "block.minecraft.oak_sapling": "dar yowynk",
  "block.minecraft.spruce_sapling": "sprus yowynk",
  "block.minecraft.birch_sapling": "besowen yowynk",
  "block.minecraft.jungle_sapling": "gwydhen yowynk gwylgos",
  "block.minecraft.acacia_sapling": "akasia yowynk",
  "block.minecraft.dark_oak_sapling": "dar tewal yowynk",
  "block.minecraft.bedrock": "bengarrek",
  "block.minecraft.sand": "tewes",
  "block.minecraft.red_sand": "tewes rudh",
  "block.minecraft.gravel": "grow",
  "block.minecraft.gold_ore": "moon owr",
  "block.minecraft.iron_ore": "moon horn",
  "block.minecraft.coal_ore": "moon glow",
  "block.minecraft.nether_gold_ore": "moon owr nether",
  "block.minecraft.oak_log": "kyf dar",
  "block.minecraft.spruce_log": "kyf sprus",
  "block.minecraft.birch_log": "kyf besow",
  "block.minecraft.jungle_log": "kyf gwylgos",
  "block.minecraft.acacia_log": "kyf akasia",
  "block.minecraft.dark_oak_log": "kyf dar tewal",
  "block.minecraft.crimson_stem": "garen gogh",
  "block.minecraft.warped_stem": "garen goynt",
  "block.minecraft.stripped_oak_log": "kyf dar lommhes",
  "block.minecraft.stripped_spruce_log": "kyf sprus lommhes",
  "block.minecraft.stripped_birch_log": "kyf besow lommhes",
  "block.minecraft.stripped_jungle_log": "kyf gwylgos lommhes",
  "block.minecraft.stripped_acacia_log": "kyf akasia lommhes",
  "block.minecraft.stripped_dark_oak_log": "kyf dar tewal lommhes",
  "block.minecraft.stripped_crimson_stem": "garen gogh destryppys",
  "block.minecraft.stripped_warped_stem": "garen goynt destryppys",
  "block.minecraft.stripped_oak_wood": "prenn dar lommhes",
  "block.minecraft.stripped_spruce_wood": "prenn sprus lommhes",
  "block.minecraft.stripped_birch_wood": "prenn besow destryppys",
  "block.minecraft.stripped_jungle_wood": "prenn gwylgos destryppys",
  "block.minecraft.stripped_acacia_wood": "prenn akasia destryppys",
  "block.minecraft.stripped_dark_oak_wood": "prenn dar tewal destryppys",
  "block.minecraft.stripped_crimson_hyphae": "trethow kogh destryppys",
  "block.minecraft.stripped_warped_hyphae": "trethow koynt destryppys",
  "block.minecraft.oak_wood": "prenn dar",
  "block.minecraft.spruce_wood": "prenn sprus",
  "block.minecraft.birch_wood": "prenn besow",
  "block.minecraft.jungle_wood": "prenn gwylgos",
  "block.minecraft.acacia_wood": "prenn akasia",
  "block.minecraft.dark_oak_wood": "prenn dar tewal",
  "block.minecraft.crimson_hyphae": "trethow kogh",
  "block.minecraft.warped_hyphae": "trethow koynt",
  "block.minecraft.oak_leaves": "del dar",
  "block.minecraft.spruce_leaves": "del sprus",
  "block.minecraft.birch_leaves": "del besow",
  "block.minecraft.jungle_leaves": "del gwylgos",
  "block.minecraft.acacia_leaves": "del akasia",
  "block.minecraft.dark_oak_leaves": "del dar tewal",
  "block.minecraft.sponge": "spong",
  "block.minecraft.wet_sponge": "spong glyb",
  "block.minecraft.glass": "gweder",
  "block.minecraft.lapis_ore": "moon lapis",
  "block.minecraft.lapis_block": "stock lapis",
  "block.minecraft.dispenser": "lesrannell",
  "block.minecraft.sandstone": "krag",
  "block.minecraft.chiseled_sandstone": "krag kervys",
  "block.minecraft.cut_sandstone": "krag treghys",
  "block.minecraft.note_block": "stock noten",
  "block.minecraft.powered_rail": "hyns horn tredanek",
  "block.minecraft.detector_rail": "hyns horn helerghi",
  "block.minecraft.sticky_piston": "pyston glusek",
  "block.minecraft.cobweb": "gwias kevnis",
  "block.minecraft.grass": "gwels",
  "block.minecraft.fern": "redenen",
  "block.minecraft.dead_bush": "prysken varow",
  "block.minecraft.seagrass": "gwels mor",
  "block.minecraft.sea_pickle": "pyckel mor",
  "block.minecraft.piston": "pyston",
  "block.minecraft.white_wool": "gwlan gwynn",
  "block.minecraft.orange_wool": "gwlan rudhvelyn",
  "block.minecraft.magenta_wool": "gwlan majenta",
  "block.minecraft.light_blue_wool": "gwlan glaswynn",
  "block.minecraft.yellow_wool": "gwlan melyn",
  "block.minecraft.lime_wool": "gwlan gwynnwyrdh",
  "block.minecraft.pink_wool": "gwlan gwynnrudh",
  "block.minecraft.gray_wool": "gwlan loos",
  "block.minecraft.light_gray_wool": "gwlan gwynnloos",
  "block.minecraft.cyan_wool": "gwlan glaswyrdh",
  "block.minecraft.purple_wool": "gwlan purpur",
  "block.minecraft.blue_wool": "gwlan glas",
  "block.minecraft.brown_wool": "gwlan gell",
  "block.minecraft.green_wool": "gwlan gwyrdh",
  "block.minecraft.red_wool": "gwlan rudh",
  "block.minecraft.black_wool": "gwlan du",
  "block.minecraft.dandelion": "dans lew",
  "block.minecraft.poppy": "myll",
  "block.minecraft.blue_orchid": "tegyrinen las",
  "block.minecraft.allium": "keninen",
  "block.minecraft.azure_bluet": "arlodhesow krener",
  "block.minecraft.red_tulip": "tulyfant rudh",
  "block.minecraft.orange_tulip": "tulyfant rudhvelyn",
  "block.minecraft.white_tulip": "tulyfant gwynn",
  "block.minecraft.pink_tulip": "tulyfant gwynnrudh",
  "block.minecraft.oxeye_daisy": "boreles",
  "block.minecraft.cornflower": "glasik",
  "block.minecraft.lily_of_the_valley": "losow an hav",
  "block.minecraft.wither_rose": "rosyn wither",
  "block.minecraft.brown_mushroom": "skavel gronek ell",
  "block.minecraft.red_mushroom": "skavel gronek rudh",
  "block.minecraft.crimson_fungus": "fong kogh",
  "block.minecraft.warped_fungus": "fong koynt",
  "block.minecraft.crimson_roots": "gwreydh kogh",
  "block.minecraft.warped_roots": "gwreydh koynt",
  "block.minecraft.nether_sprouts": "kowligow nether",
  "block.minecraft.weeping_vines": "gwinbrennyer ola",
  "block.minecraft.twisting_vines": "gwinbrennyer nedha",
  "block.minecraft.sugar_cane": "gwelen sugra",
  "block.minecraft.kelp": "gommon",
  "block.minecraft.bamboo": "kors eynda",
  "block.minecraft.gold_block": "stock owr",
  "block.minecraft.iron_block": "stock horn",
  "block.minecraft.oak_slab": "leghen dhar",
  "block.minecraft.spruce_slab": "leghen sprus",
  "block.minecraft.birch_slab": "leghen vesow",
  "block.minecraft.jungle_slab": "leghen wylgos",
  "block.minecraft.acacia_slab": "leghen akasia",
  "block.minecraft.dark_oak_slab": "leghen dhar tewal",
  "block.minecraft.crimson_slab": "leghen gogh",
  "block.minecraft.warped_slab": "leghen goynt",
  "block.minecraft.stone_slab": "leghen ven",
  "block.minecraft.smooth_stone_slab": "leghen ven smodh",
  "block.minecraft.sandstone_slab": "leghen grag",
  "block.minecraft.cut_sandstone_slab": "leghen grag treghys",
  "block.minecraft.petrified_oak_slab": "leghen dhar menhes",
  "block.minecraft.cobblestone_slab": "leghen ven kauns",
  "block.minecraft.brick_slab": "leghen vryck",
  "block.minecraft.stone_brick_slab": "leghen vryck men",
  "block.minecraft.nether_brick_slab": "leghen vryck nether",
  "block.minecraft.quartz_slab": "leghen ganndir",
  "block.minecraft.red_sandstone_slab": "leghen grag rudh",
  "block.minecraft.cut_red_sandstone_slab": "leghen grag rudh treghys",
  "block.minecraft.purpur_slab": "leghen burpur",
  "block.minecraft.prismarine_slab": "leghen brismarin",
  "block.minecraft.prismarine_brick_slab": "leghen vryck prismarin",
  "block.minecraft.dark_prismarine_slab": "leghen brismarin tewal",
  "block.minecraft.smooth_quartz": "stock kanndir smodh",
  "block.minecraft.smooth_red_sandstone": "krag rudh smodh",
  "block.minecraft.smooth_sandstone": "krag smodh",
  "block.minecraft.smooth_stone": "men smodh",
  "block.minecraft.bricks": "bryckys",
  "block.minecraft.tnt": "dynamit",
  "block.minecraft.bookshelf": "argh lyvrow",
  "block.minecraft.mossy_cobblestone": "men kauns kewniek",
  "block.minecraft.obsidian": "obsydyann",
  "block.minecraft.torch": "faglen",
  "block.minecraft.end_rod": "gwelen an diwedh",
  "block.minecraft.chorus_plant": "losowen koros",
  "block.minecraft.chorus_flower": "bleujen goros",
  "block.minecraft.purpur_block": "stock purpur",
  "block.minecraft.purpur_pillar": "koloven burpur",
  "block.minecraft.purpur_stairs": "grisyow purpur",
  "block.minecraft.spawner": "bewher",
  "block.minecraft.oak_stairs": "grisyow dar",
  "block.minecraft.chest": "kist",
  "block.minecraft.diamond_ore": "moon adamant",
  "block.minecraft.diamond_block": "stock adamant",
  "block.minecraft.crafting_table": "moos kreftya",
  "block.minecraft.farmland": "bargen tir",
  "block.minecraft.furnace": "fog",
  "block.minecraft.ladder": "skeul",
  "block.minecraft.rail": "hyns horn",
  "block.minecraft.cobblestone_stairs": "grisyow men kauns",
  "block.minecraft.lever": "kolpes",
  "block.minecraft.stone_pressure_plate": "plat gwaskedh men",
  "block.minecraft.oak_pressure_plate": "plat gwaskedh dar",
  "block.minecraft.spruce_pressure_plate": "plat gwaskedh sprus",
  "block.minecraft.birch_pressure_plate": "plat gwaskedh besow",
  "block.minecraft.jungle_pressure_plate": "plat gwaskedh gwylgos",
  "block.minecraft.acacia_pressure_plate": "plat gwaskedh akasia",
  "block.minecraft.dark_oak_pressure_plate": "plat gwaskedh dar tewal",
  "block.minecraft.crimson_pressure_plate": "plat gwaskedh kogh",
  "block.minecraft.warped_pressure_plate": "gwaskleghen goynt",
  "block.minecraft.polished_blackstone_pressure_plate": "plat gwaskedh men du polsys",
  "block.minecraft.redstone_ore": "moon menrudh",
  "block.minecraft.redstone_torch": "faglen menrudh",
  "block.minecraft.snow": "ergh",
  "block.minecraft.ice": "rew",
  "block.minecraft.snow_block": "stock ergh",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "pri",
  "block.minecraft.jukebox": "troyllyer",
  "block.minecraft.oak_fence": "ke dar",
  "block.minecraft.spruce_fence": "ke sprus",
  "block.minecraft.birch_fence": "ke besow",
  "block.minecraft.jungle_fence": "ke prenn gwylgos",
  "block.minecraft.acacia_fence": "ke akasia",
  "block.minecraft.dark_oak_fence": "ke dar tewal",
  "block.minecraft.crimson_fence": "ke kogh",
  "block.minecraft.warped_fence": "ke koynt",
  "block.minecraft.pumpkin": "pompyon",
  "block.minecraft.carved_pumpkin": "pompyon kervys",
  "block.minecraft.netherrack": "yfarngarrek",
  "block.minecraft.soul_sand": "tewes enev",
  "block.minecraft.soul_soil": "dor enev",
  "block.minecraft.basalt": "pyllargarrek",
  "block.minecraft.polished_basalt": "pyllargarrek bolsys",
  "block.minecraft.soul_torch": "faglen enev",
  "block.minecraft.glowstone": "men splann",
  "block.minecraft.jack_o_lantern": "lugarn pompyon",
  "block.minecraft.oak_trapdoor": "lo an jowl dar",
  "block.minecraft.spruce_trapdoor": "lo an jowl sprus",
  "block.minecraft.birch_trapdoor": "lo an jowl besow",
  "block.minecraft.jungle_trapdoor": "lo an jowl gwylgos",
  "block.minecraft.acacia_trapdoor": "lo an jowl akasia",
  "block.minecraft.dark_oak_trapdoor": "lo an jowl dar tewal",
  "block.minecraft.crimson_trapdoor": "lo an jowl kogh",
  "block.minecraft.warped_trapdoor": "lo an jowl koynt",
  "block.minecraft.infested_stone": "men pla",
  "block.minecraft.infested_cobblestone": "men kauns plagys",
  "block.minecraft.infested_stone_bricks": "bryckys men pla",
  "block.minecraft.infested_mossy_stone_bricks": "bryckys men pla kewniek",
  "block.minecraft.infested_cracked_stone_bricks": "bryckys men pla krackys",
  "block.minecraft.infested_chiseled_stone_bricks": "bryckys men pla gennys",
  "block.minecraft.stone_bricks": "bryckys men",
  "block.minecraft.mossy_stone_bricks": "bryckys men kewniek",
  "block.minecraft.cracked_stone_bricks": "bryckys men krackys",
  "block.minecraft.chiseled_stone_bricks": "bryckys meyn kervys",
  "block.minecraft.brown_mushroom_block": "stock skavel gronek ell",
  "block.minecraft.red_mushroom_block": "stock skavel gronek rudh",
  "block.minecraft.mushroom_stem": "garen skavel gronek",
  "block.minecraft.iron_bars": "prennyer horn",
  "block.minecraft.chain": "chayn",
  "block.minecraft.glass_pane": "kwarel",
  "block.minecraft.melon": "pompyon hweg",
  "block.minecraft.vine": "gwinbrennyer",
  "block.minecraft.oak_fence_gate": "yet ke dar",
  "block.minecraft.spruce_fence_gate": "yet ke sprus",
  "block.minecraft.birch_fence_gate": "yet ke besow",
  "block.minecraft.jungle_fence_gate": "yet ke prenn gwylgos",
  "block.minecraft.acacia_fence_gate": "yet ke akasia",
  "block.minecraft.dark_oak_fence_gate": "yet ke dar tewal",
  "block.minecraft.crimson_fence_gate": "yet ke kogh",
  "block.minecraft.warped_fence_gate": "yet ke koynt",
  "block.minecraft.brick_stairs": "grisyow bryck",
  "block.minecraft.stone_brick_stairs": "grisyow bryck men",
  "block.minecraft.mycelium": "towargh tewl",
  "block.minecraft.lily_pad": "padyn lili",
  "block.minecraft.nether_bricks": "bryckys nether",
  "block.minecraft.cracked_nether_bricks": "bryckys nether krackys",
  "block.minecraft.chiseled_nether_bricks": "bryckys nether kervys",
  "block.minecraft.nether_brick_fence": "ke bryckys yfarngarrek",
  "block.minecraft.nether_brick_stairs": "grisyow vryckys yfarngarrek",
  "block.minecraft.enchanting_table": "moos hus",
  "block.minecraft.end_portal_frame": "fram porth an end",
  "block.minecraft.end_stone": "men an diwedh",
  "block.minecraft.end_stone_bricks": "bryckys men an diwedh",
  "block.minecraft.dragon_egg": "oy dragon",
  "block.minecraft.redstone_lamp": "lugarn menrudh",
  "block.minecraft.sandstone_stairs": "grisyow krag",
  "block.minecraft.emerald_ore": "moon gwerem",
  "block.minecraft.ender_chest": "kist an diwedh",
  "block.minecraft.tripwire_hook": "higen rag gwivren",
  "block.minecraft.emerald_block": "stock gwerem",
  "block.minecraft.spruce_stairs": "grisyow sprus",
  "block.minecraft.birch_stairs": "grisyow besow",
  "block.minecraft.jungle_stairs": "grisyow gwylgos",
  "block.minecraft.crimson_stairs": "grisyow kogh",
  "block.minecraft.warped_stairs": "grisyow koynt",
  "block.minecraft.command_block": "stock gorhemmyn",
  "block.minecraft.beacon": "golowva",
  "block.minecraft.cobblestone_wall": "fos men kauns",
  "block.minecraft.mossy_cobblestone_wall": "fos men kauns kewniek",
  "block.minecraft.brick_wall": "fos bryck",
  "block.minecraft.prismarine_wall": "fos prismarin",
  "block.minecraft.red_sandstone_wall": "fos krag rudh",
  "block.minecraft.mossy_stone_brick_wall": "fos bryck men kewniek",
  "block.minecraft.granite_wall": "fos growan",
  "block.minecraft.stone_brick_wall": "fos bryck men",
  "block.minecraft.nether_brick_wall": "fos bryck nether",
  "block.minecraft.andesite_wall": "fos andesit",
  "block.minecraft.red_nether_brick_wall": "fos bryck nether rudh",
  "block.minecraft.sandstone_wall": "fos krag",
  "block.minecraft.end_stone_brick_wall": "fos bryck men an diwedh",
  "block.minecraft.diorite_wall": "fos diorit",
  "block.minecraft.blackstone_wall": "fos ven du",
  "block.minecraft.polished_blackstone_wall": "fos ven du polsys",
  "block.minecraft.polished_blackstone_brick_wall": "fos vryck men du polsys",
  "block.minecraft.stone_button": "boton men",
  "block.minecraft.oak_button": "boton dar",
  "block.minecraft.spruce_button": "boton sprus",
  "block.minecraft.birch_button": "boton besow",
  "block.minecraft.jungle_button": "boton gwylgos",
  "block.minecraft.acacia_button": "boton akasia",
  "block.minecraft.dark_oak_button": "boton dar tewal",
  "block.minecraft.crimson_button": "boton kogh",
  "block.minecraft.warped_button": "boton koynt",
  "block.minecraft.polished_blackstone_button": "boton mendhu polsys",
  "block.minecraft.anvil": "anwan",
  "block.minecraft.chipped_anvil": "anwan asklosys",
  "block.minecraft.damaged_anvil": "anwan kisys",
  "block.minecraft.trapped_chest": "kist gans maglen",
  "block.minecraft.light_weighted_pressure_plate": "plat gwaskedh skav",
  "block.minecraft.heavy_weighted_pressure_plate": "plat gwaskedh poos",
  "block.minecraft.daylight_detector": "sensour golow an howl",
  "block.minecraft.redstone_block": "stock menrudh",
  "block.minecraft.nether_quartz_ore": "moon kanndir nether",
  "block.minecraft.hopper": "funnel",
  "block.minecraft.chiseled_quartz_block": "stock kanndir kervys",
  "block.minecraft.quartz_block": "stock kanndir",
  "block.minecraft.quartz_bricks": "bryckys kanndir",
  "block.minecraft.quartz_pillar": "koloven ganndir",
  "block.minecraft.quartz_stairs": "grisyow kanndir",
  "block.minecraft.activator_rail": "hyns horn bewhe",
  "block.minecraft.dropper": "droppyer",
  "block.minecraft.white_terracotta": "pri pebys gwynn",
  "block.minecraft.orange_terracotta": "pri pebys rudhvelyn",
  "block.minecraft.magenta_terracotta": "pri pebys majenta",
  "block.minecraft.light_blue_terracotta": "pri pebys glaswynn",
  "block.minecraft.yellow_terracotta": "pri pebys melyn",
  "block.minecraft.lime_terracotta": "pri pebys gwynnwyrdh",
  "block.minecraft.pink_terracotta": "pri pebys gwynnrudh",
  "block.minecraft.gray_terracotta": "pri pebys loos",
  "block.minecraft.light_gray_terracotta": "pri pebys gwynnloos",
  "block.minecraft.cyan_terracotta": "pri pebys glaswyrdh",
  "block.minecraft.purple_terracotta": "pri pebys purpur",
  "block.minecraft.blue_terracotta": "pri pebys glas",
  "block.minecraft.brown_terracotta": "pri pebys gell",
  "block.minecraft.green_terracotta": "pri pebys gwyrdh",
  "block.minecraft.red_terracotta": "pri pebys rudh",
  "block.minecraft.black_terracotta": "pri pebys du",
  "block.minecraft.barrier": "lett",
  "block.minecraft.iron_trapdoor": "lo an jowl horn",
  "block.minecraft.hay_block": "pusorn a wora",
  "block.minecraft.white_carpet": "leurlen wynn",
  "block.minecraft.orange_carpet": "leurlen rudhvelyn",
  "block.minecraft.magenta_carpet": "leurlen vajenta",
  "block.minecraft.light_blue_carpet": "leurlen laswynn",
  "block.minecraft.yellow_carpet": "leurlen velyn",
  "block.minecraft.lime_carpet": "leurlen wynnwyrdh",
  "block.minecraft.pink_carpet": "leurlen wynnrudh",
  "block.minecraft.gray_carpet": "leurlen loos",
  "block.minecraft.light_gray_carpet": "leurlen wynnloos",
  "block.minecraft.cyan_carpet": "leurlen glaswyrdh",
  "block.minecraft.purple_carpet": "leurlen burpur",
  "block.minecraft.blue_carpet": "leurlen las",
  "block.minecraft.brown_carpet": "leurlen ell",
  "block.minecraft.green_carpet": "leurlen wyrdh",
  "block.minecraft.red_carpet": "leurlen rudh",
  "block.minecraft.black_carpet": "leurlen dhu",
  "block.minecraft.terracotta": "pri pebys",
  "block.minecraft.coal_block": "stock glow",
  "block.minecraft.packed_ice": "rew kales",
  "block.minecraft.acacia_stairs": "grisyow akasia",
  "block.minecraft.dark_oak_stairs": "grisyow dar tewal",
  "block.minecraft.slime_block": "stock slim",
  "block.minecraft.grass_path": "hyns gwels",
  "block.minecraft.sunflower": "bleujen an howl",
  "block.minecraft.lilac": "bleujen lilac",
  "block.minecraft.rose_bush": "prysken ros",
  "block.minecraft.peony": "rosen venydh",
  "block.minecraft.tall_grass": "gwels hir",
  "block.minecraft.large_fern": "redenen vras",
  "block.minecraft.white_stained_glass": "gweder nammys gwynn",
  "block.minecraft.orange_stained_glass": "gweder nammys rudhvelyn",
  "block.minecraft.magenta_stained_glass": "gweder nammys majenta",
  "block.minecraft.light_blue_stained_glass": "gweder nammys glaswynn",
  "block.minecraft.yellow_stained_glass": "gweder nammys melyn",
  "block.minecraft.lime_stained_glass": "gweder nammys gwynnwyrdh",
  "block.minecraft.pink_stained_glass": "gweder nammys gwynnrudh",
  "block.minecraft.gray_stained_glass": "gweder nammys loos",
  "block.minecraft.light_gray_stained_glass": "gweder nammys gwynnloos",
  "block.minecraft.cyan_stained_glass": "gweder nammys glaswyrdh",
  "block.minecraft.purple_stained_glass": "gweder nammys purpur",
  "block.minecraft.blue_stained_glass": "gweder nammys glas",
  "block.minecraft.brown_stained_glass": "gweder nammys gell",
  "block.minecraft.green_stained_glass": "gweder nammys gwyrdh",
  "block.minecraft.red_stained_glass": "gweder nammys rudh",
  "block.minecraft.black_stained_glass": "gweder nammys du",
  "block.minecraft.white_stained_glass_pane": "kwarel nammys gwynn",
  "block.minecraft.orange_stained_glass_pane": "kwarel nammys rudhvelyn",
  "block.minecraft.magenta_stained_glass_pane": "kwarel nammys majenta",
  "block.minecraft.light_blue_stained_glass_pane": "kwarel nammys glaswynn",
  "block.minecraft.yellow_stained_glass_pane": "kwarel nammys melyn",
  "block.minecraft.lime_stained_glass_pane": "kwarel nammys gwynnwyrdh",
  "block.minecraft.pink_stained_glass_pane": "kwarel nammys rudhwynn",
  "block.minecraft.gray_stained_glass_pane": "kwarel nammys loos",
  "block.minecraft.light_gray_stained_glass_pane": "kwarel nammys gwynnloos",
  "block.minecraft.cyan_stained_glass_pane": "kwarel nammys glaswyrdh",
  "block.minecraft.purple_stained_glass_pane": "kwarel nammys purpur",
  "block.minecraft.blue_stained_glass_pane": "kwarel nammys glas",
  "block.minecraft.brown_stained_glass_pane": "kwarel nammys gell",
  "block.minecraft.green_stained_glass_pane": "kwarel nammys gwyrdh",
  "block.minecraft.red_stained_glass_pane": "kwarel nammys rudh",
  "block.minecraft.black_stained_glass_pane": "kwarel nammys du",
  "block.minecraft.prismarine": "prismarin",
  "block.minecraft.prismarine_bricks": "bryckys prismarin",
  "block.minecraft.dark_prismarine": "prismarin tewal",
  "block.minecraft.prismarine_stairs": "grisyow prismarin",
  "block.minecraft.prismarine_brick_stairs": "grisyow bryck prismarin",
  "block.minecraft.dark_prismarine_stairs": "grisyow prismarin tewal",
  "block.minecraft.sea_lantern": "lugarn an mor",
  "block.minecraft.red_sandstone": "krag rudh",
  "block.minecraft.chiseled_red_sandstone": "krag rudh kervys",
  "block.minecraft.cut_red_sandstone": "krag rudh treghys",
  "block.minecraft.red_sandstone_stairs": "grisyow krag rudh",
  "block.minecraft.repeating_command_block": "stock gorhemmyn daswul",
  "block.minecraft.chain_command_block": "stock gorhemmyn chayn",
  "block.minecraft.magma_block": "stock magma",
  "block.minecraft.nether_wart_block": "stock losow an yfarn",
  "block.minecraft.warped_wart_block": "stock a losow koynt",
  "block.minecraft.red_nether_bricks": "bryckys nether rudh",
  "block.minecraft.bone_block": "stock askorn",
  "block.minecraft.structure_void": "gwagle strethur",
  "block.minecraft.observer": "mirer",
  "block.minecraft.shulker_box": "boks shulker",
  "block.minecraft.white_shulker_box": "boks shulker gwynn",
  "block.minecraft.orange_shulker_box": "boks shulker rudhvelyn",
  "block.minecraft.magenta_shulker_box": "boks shulker majenta",
  "block.minecraft.light_blue_shulker_box": "boks shulker glaswynn",
  "block.minecraft.yellow_shulker_box": "boks shulker melyn",
  "block.minecraft.lime_shulker_box": "boks shulker gwynnwyrdh",
  "block.minecraft.pink_shulker_box": "boks shulker gwynnrudh",
  "block.minecraft.gray_shulker_box": "boks shulker loos",
  "block.minecraft.light_gray_shulker_box": "boks shulker gwynnloos",
  "block.minecraft.cyan_shulker_box": "boks shulker glaswyrdh",
  "block.minecraft.purple_shulker_box": "boks shulker purpur",
  "block.minecraft.blue_shulker_box": "boks shulker glas",
  "block.minecraft.brown_shulker_box": "boks shulker gell",
  "block.minecraft.green_shulker_box": "boks shulker gwyrdh",
  "block.minecraft.red_shulker_box": "boks shulker rudh",
  "block.minecraft.black_shulker_box": "boks shulker du",
  "block.minecraft.white_glazed_terracotta": "pri pebys gwedrys gwynn",
  "block.minecraft.orange_glazed_terracotta": "pri pebys gwedrys rudhvelyn",
  "block.minecraft.magenta_glazed_terracotta": "pri pebys gwedrys majenta",
  "block.minecraft.light_blue_glazed_terracotta": "pri pebys gwedrys glaswynn",
  "block.minecraft.yellow_glazed_terracotta": "pri pebys gwedrys melyn",
  "block.minecraft.lime_glazed_terracotta": "pri pebys gwedrys gwynnwyrdh",
  "block.minecraft.pink_glazed_terracotta": "pri pebys gwedrys rudhwynn",
  "block.minecraft.gray_glazed_terracotta": "pri pebys gwedrys loos",
  "block.minecraft.light_gray_glazed_terracotta": "pri pebys gwedrys gwynnloos",
  "block.minecraft.cyan_glazed_terracotta": "pri pebys gwedrys glaswyrdh",
  "block.minecraft.purple_glazed_terracotta": "pri pebys gwedrys purpur",
  "block.minecraft.blue_glazed_terracotta": "pri pebys gwedrys glas",
  "block.minecraft.brown_glazed_terracotta": "pri pebys gwedrys gell",
  "block.minecraft.green_glazed_terracotta": "pri pebys gwedrys gwyrdh",
  "block.minecraft.red_glazed_terracotta": "pri pebys gwedrys rudh",
  "block.minecraft.black_glazed_terracotta": "pri pebys gwedrys du",
  "block.minecraft.white_concrete": "kestevyn gwynn",
  "block.minecraft.orange_concrete": "kestevyn rudhvelyn",
  "block.minecraft.magenta_concrete": "kestevyn majenta",
  "block.minecraft.light_blue_concrete": "kestevyn glaswynn",
  "block.minecraft.yellow_concrete": "kestevyn melyn",
  "block.minecraft.lime_concrete": "kestevyn gwynnwyrdh",
  "block.minecraft.pink_concrete": "kestevyn gwynnrudh",
  "block.minecraft.gray_concrete": "kestevyn loos",
  "block.minecraft.light_gray_concrete": "kestevyn gwynnloos",
  "block.minecraft.cyan_concrete": "kestevyn glaswyrdh",
  "block.minecraft.purple_concrete": "kestevyn purpur",
  "block.minecraft.blue_concrete": "kestevyn glas",
  "block.minecraft.brown_concrete": "kestevyn gell",
  "block.minecraft.green_concrete": "kestevyn gwyrdh",
  "block.minecraft.red_concrete": "kestevyn rudh",
  "block.minecraft.black_concrete": "kestevyn du",
  "block.minecraft.white_concrete_powder": "ponn kestevyn gwynn",
  "block.minecraft.orange_concrete_powder": "ponn kestevyn rudhvelyn",
  "block.minecraft.magenta_concrete_powder": "ponn kestevyn majenta",
  "block.minecraft.light_blue_concrete_powder": "ponn kestevyn glaswynn",
  "block.minecraft.yellow_concrete_powder": "ponn kestevyn melyn",
  "block.minecraft.lime_concrete_powder": "ponn kestevyn gwynnwyrdh",
  "block.minecraft.pink_concrete_powder": "ponn kestevyn gwynnrudh",
  "block.minecraft.gray_concrete_powder": "ponn kestevyn loos",
  "block.minecraft.light_gray_concrete_powder": "ponn kestevyn gwynnloos",
  "block.minecraft.cyan_concrete_powder": "ponn kestevyn glaswyrdh",
  "block.minecraft.purple_concrete_powder": "ponn kestevyn purpur",
  "block.minecraft.blue_concrete_powder": "ponn kestevyn glas",
  "block.minecraft.brown_concrete_powder": "ponn kestevyn gell",
  "block.minecraft.green_concrete_powder": "ponn kestevyn gwyrdh",
  "block.minecraft.red_concrete_powder": "ponn kestevyn rudh",
  "block.minecraft.black_concrete_powder": "ponn kestevyn du",
  "block.minecraft.turtle_egg": "oy morgroban",
  "block.minecraft.dead_tube_coral_block": "stock korel piben marow",
  "block.minecraft.dead_brain_coral_block": "stock korel ympynnyon marow",
  "block.minecraft.dead_bubble_coral_block": "stock korel hwethen marow",
  "block.minecraft.dead_fire_coral_block": "stock korel tan marow",
  "block.minecraft.dead_horn_coral_block": "stock korel korn marow",
  "block.minecraft.tube_coral_block": "stock korel piben",
  "block.minecraft.brain_coral_block": "stock korel ympynnyon",
  "block.minecraft.bubble_coral_block": "stock korel hwethen",
  "block.minecraft.fire_coral_block": "stock korel tan",
  "block.minecraft.horn_coral_block": "stock korel korn",
  "block.minecraft.tube_coral": "korel piben",
  "block.minecraft.brain_coral": "korel ympynnyon",
  "block.minecraft.bubble_coral": "korel hwethen",
  "block.minecraft.fire_coral": "korel tan",
  "block.minecraft.horn_coral": "korel korn",
  "block.minecraft.dead_brain_coral": "korel ympynnyon marow",
  "block.minecraft.dead_bubble_coral": "korel hwethen marow",
  "block.minecraft.dead_fire_coral": "korel tan marow",
  "block.minecraft.dead_horn_coral": "korel korn marow",
  "block.minecraft.dead_tube_coral": "korel piben marow",
  "block.minecraft.tube_coral_fan": "fan korel piben",
  "block.minecraft.brain_coral_fan": "fan korel ympynnyon",
  "block.minecraft.bubble_coral_fan": "fan korel hwethen",
  "block.minecraft.fire_coral_fan": "fan korel tan",
  "block.minecraft.horn_coral_fan": "fan korel korn",
  "block.minecraft.dead_tube_coral_fan": "fan korel piben marow",
  "block.minecraft.dead_brain_coral_fan": "fan korel ympynnyon marow",
  "block.minecraft.dead_bubble_coral_fan": "fan korel hwethen marow",
  "block.minecraft.dead_fire_coral_fan": "fan korel tan marow",
  "block.minecraft.dead_horn_coral_fan": "fan korel korn marow",
  "block.minecraft.blue_ice": "rew glas",
  "block.minecraft.conduit": "gooth",
  "block.minecraft.polished_granite_stairs": "grisyow growan polsys",
  "block.minecraft.smooth_red_sandstone_stairs": "grisyow krag rudh smodh",
  "block.minecraft.mossy_stone_brick_stairs": "grisyow bryck men kewniek",
  "block.minecraft.polished_diorite_stairs": "grisyow diorit polsys",
  "block.minecraft.mossy_cobblestone_stairs": "grisyow men kauns kewniek",
  "block.minecraft.end_stone_brick_stairs": "grisyow bryck men an diwedh",
  "block.minecraft.stone_stairs": "grisyow men",
  "block.minecraft.smooth_sandstone_stairs": "grisyow krag smodh",
  "block.minecraft.smooth_quartz_stairs": "grisyow kanndir smodh",
  "block.minecraft.granite_stairs": "grisyow growan",
  "block.minecraft.andesite_stairs": "grisyow andesit",
  "block.minecraft.red_nether_brick_stairs": "grisyow bryck nether rudh",
  "block.minecraft.polished_andesite_stairs": "grisyow andesit polsys",
  "block.minecraft.diorite_stairs": "grisyow diorit",
  "block.minecraft.polished_granite_slab": "leghen wrowan polsys",
  "block.minecraft.smooth_red_sandstone_slab": "leghen grag rudh smodh",
  "block.minecraft.mossy_stone_brick_slab": "leghen vryck men kewniek",
  "block.minecraft.polished_diorite_slab": "leghen dhiorit polsys",
  "block.minecraft.mossy_cobblestone_slab": "leghen ven kauns kewniek",
  "block.minecraft.end_stone_brick_slab": "leghen vryck men an diwedh",
  "block.minecraft.smooth_sandstone_slab": "leghen grag smodh",
  "block.minecraft.smooth_quartz_slab": "leghen ganndir smodh",
  "block.minecraft.granite_slab": "leghen wrowan",
  "block.minecraft.andesite_slab": "leghen andesit",
  "block.minecraft.red_nether_brick_slab": "leghen bryck nether rudh",
  "block.minecraft.polished_andesite_slab": "leghen andesit polsys",
  "block.minecraft.diorite_slab": "leghen dhiorit",
  "block.minecraft.scaffolding": "mynk",
  "block.minecraft.iron_door": "daras horn",
  "block.minecraft.oak_door": "daras dar",
  "block.minecraft.spruce_door": "daras sprus",
  "block.minecraft.birch_door": "daras besow",
  "block.minecraft.jungle_door": "daras gwylgos",
  "block.minecraft.acacia_door": "daras akasia",
  "block.minecraft.dark_oak_door": "daras dar tewal",
  "block.minecraft.crimson_door": "daras kogh",
  "block.minecraft.warped_door": "daras koynt",
  "block.minecraft.repeater": "daswrier men rudh",
  "block.minecraft.comparator": "komparyer men rudh",
  "block.minecraft.structure_block": "stock strethur",
  "block.minecraft.jigsaw": "stock mildam",
  "item.minecraft.turtle_helmet": "krogen vorgroban□□war benn:□+2 arvwisk",
  "item.minecraft.scute": "skansen",
  "item.minecraft.iron_shovel": "pal horn□□yn leuv jyf:□+3.5 kisyans omsettyans□-3 skavder omsettyer",
  "item.minecraft.iron_pickaxe": "pigell horn□□yn leuv jyf:□+3 kisyans omsettyans□-2.8 skavder omsettyer",
  "item.minecraft.iron_axe": "bool horn□□yn leuv jyf:□+8 kisyans omsettyans□-3.1 skavder omsettyer",
  "item.minecraft.flint_and_steel": "kelester ha dur",
  "item.minecraft.apple": "aval",
  "item.minecraft.bow": "gwarek",
  "item.minecraft.arrow": "seth",
  "item.minecraft.coal": "glow",
  "item.minecraft.charcoal": "glowbren",
  "item.minecraft.diamond": "adamant",
  "item.minecraft.iron_ingot": "etewik horn",
  "item.minecraft.gold_ingot": "etewik owr",
  "item.minecraft.netherite_ingot": "etewik netherit",
  "item.minecraft.netherite_scrap": "tamm netherit",
  "item.minecraft.iron_sword": "kledha horn□□yn leuv jyf:□+5 kisyans omsettyans□-2.4 skavder omsettyer",
  "item.minecraft.wooden_sword": "kledha prenn□□yn leuv jyf:□+3 kisyans omsettyans□-2.4 skavder omsettyer",
  "item.minecraft.wooden_shovel": "pal brenn□□yn leuv jyf:□+1.5 kisyans omsettyans□-3 skavder omsettyer",
  "item.minecraft.wooden_pickaxe": "pigell brenn□□yn leuv jyf:□+1 kisyans omsettyans□-2.8 skavder omsettyer",
  "item.minecraft.wooden_axe": "bool brenn□□yn leuv jyf:□+6 kisyans omsettyans□-3.2 skavder omsettyer",
  "item.minecraft.stone_sword": "kledha men□□yn leuv jyf:□+4 kisyans omsettyans□-2.4 skavder omsettyer",
  "item.minecraft.stone_shovel": "pal ven□□yn leuv jyf:□+2.5 kisyans omsettyans□-3 skavder omsettyer",
  "item.minecraft.stone_pickaxe": "pigell ven□□yn leuv jyf:□+2 kisyans omsettyans□-2.8 skavder omsettyer",
  "item.minecraft.stone_axe": "bool ven□□yn leuv jyf:□+8 kisyans omsettyans□-3.2 skavder omsettyer",
  "item.minecraft.diamond_sword": "kledha adamant□□yn leuv jyf:□+6 kisyans omsettyans□-2.4 skavder omsettyer",
  "item.minecraft.diamond_shovel": "pal adamant□□yn leuv jyf:□+4.5 kisyans omsettyans□-3 skavder omsettyer",
  "item.minecraft.diamond_pickaxe": "pigell adamant□□yn leuv jyf:□+4 kisyans omsettyans□-2.8 skavder omsettyer",
  "item.minecraft.diamond_axe": "bool adamant□□yn leuv jyf:□+8 kisyans omsettyans□-3 skavder omsettyer",
  "item.minecraft.stick": "gwelen",
  "item.minecraft.bowl": "bolla",
  "item.minecraft.mushroom_stew": "kowl skavell gronek",
  "item.minecraft.golden_sword": "kledha owr□□yn leuv jyf:□+3 kisyans omsettyans□-2.4 skavder omsettyer",
  "item.minecraft.golden_shovel": "pal owr□□yn leuv jyf:□+1.5 kisyans omsettyans□-3 skavder omsettyer",
  "item.minecraft.golden_pickaxe": "pigell owr□□yn leuv jyf:□+1 kisyans omsettyans□-2.8 skavder omsettyer",
  "item.minecraft.golden_axe": "bool owr□□yn leuv jyf:□+6 kisyans omsettyans□-3 skavder omsettyer",
  "item.minecraft.netherite_sword": "kledha netherit□□yn leuv jyf:□+7 kisyans omsettyans□-2.4 skavder omsettyer",
  "item.minecraft.netherite_shovel": "pal netherit□□yn leuv jyf:□+5.5 kisyans omsettyans□-3 skavder omsettyer",
  "item.minecraft.netherite_pickaxe": "pigell netherit□□yn leuv jyf:□+5 kisyans omsettyans□-2.8 skavder omsettyer",
  "item.minecraft.netherite_axe": "bool netherit□□yn leuv jyf:□+9 kisyans omsettyans□-3 skavder omsettyer",
  "item.minecraft.string": "korden",
  "item.minecraft.feather": "pluven",
  "item.minecraft.gunpowder": "ponn gonn",
  "item.minecraft.wooden_hoe": "kravell brenn□□yn leuv jyf:□-3 skavder omsettyer",
  "item.minecraft.stone_hoe": "kravell ven□□yn leuv jyf:□-2 skavder omsettyer",
  "item.minecraft.iron_hoe": "kravell horn□□yn leuv jyf:□-1 skavder omsettyer",
  "item.minecraft.diamond_hoe": "kravell adamant□□yn leuv jyf:",
  "item.minecraft.golden_hoe": "kravell owr□□yn leuv jyf:□-3 skavder omsettyer",
  "item.minecraft.netherite_hoe": "kravell netherit□□yn leuv jyf:",
  "item.minecraft.wheat_seeds": "has gwaneth",
  "item.minecraft.wheat": "gwaneth",
  "item.minecraft.bread": "bara",
  "item.minecraft.leather_helmet": "kappa ledher□□war benn:□+1 arvwisk",
  "item.minecraft.leather_chestplate": "lurik ledher□□war gorf:□+3 arvwisk",
  "item.minecraft.leather_leggings": "lavrek ledher□□war dhiwarr:□+2 arvwisk",
  "item.minecraft.leather_boots": "botas ledher□□war dhewdros:□+1 arvwisk",
  "item.minecraft.chainmail_helmet": "basnet chayn□□war benn:□+2 arvwisk",
  "item.minecraft.chainmail_chestplate": "lurik chayn□□war gorf:□+5 arvwisk",
  "item.minecraft.chainmail_leggings": "lavrek chayn□□war dhiwarr:□+4 arvwisk",
  "item.minecraft.chainmail_boots": "botas chayn□□war dhewdros:□+1 arvwisk",
  "item.minecraft.iron_helmet": "basnet horn□□war benn:□+2 arvwisk",
  "item.minecraft.iron_chestplate": "lurik horn□□war gorf:□+6 arvwisk",
  "item.minecraft.iron_leggings": "lavrek horn□□war dhiwarr:□+5 arvwisk",
  "item.minecraft.iron_boots": "botas horn□□war dhewdros:□+2 arvwisk",
  "item.minecraft.diamond_helmet": "basnet adamant□□war benn:□+3 arvwisk□+2 kaletter arvwisk",
  "item.minecraft.diamond_chestplate": "lurik adamant□□war gorf:□+8 arvwisk□+2 kaletter arvwisk",
  "item.minecraft.diamond_leggings": "lavrek adamant□□war dhiwarr:□+6 arvwisk□+2 kaletter arvwisk",
  "item.minecraft.diamond_boots": "botas adamant□□war dhewdros:□+3 arvwisk□+2 kaletter arvwisk",
  "item.minecraft.golden_helmet": "basnet owr□□war benn:□+2 arvwisk",
  "item.minecraft.golden_chestplate": "lurik owr□□war gorf:□+5 arvwisk",
  "item.minecraft.golden_leggings": "lavrek owr□□war dhiwarr:□+3 arvwisk",
  "item.minecraft.golden_boots": "botas owr□□war dhewdros:□+1 arvwisk",
  "item.minecraft.netherite_helmet": "basnet netherit□□war benn:□+3 arvwisk□+3 kaletter arvwisk□+1 defens herdhya",
  "item.minecraft.netherite_chestplate": "brestplat netherit□□war gorf:□+8 arvwisk□+3 kaletter arvwisk□+1 defens herdhya",
  "item.minecraft.netherite_leggings": "lavrek netherit□□war dhiwarr:□+6 arvwisk□+3 kaletter arvwisk□+1 defens herdhya",
  "item.minecraft.netherite_boots": "botas netherit□□war dhewdros:□+3 arvwisk□+3 kaletter arvwisk□+1 defens herdhya",
  "item.minecraft.flint": "kelester",
  "item.minecraft.porkchop": "kig mogh kriv",
  "item.minecraft.cooked_porkchop": "kig mogh keginys",
  "item.minecraft.painting": "lymnans",
  "item.minecraft.golden_apple": "aval owr",
  "item.minecraft.enchanted_golden_apple": "aval owr gans hus",
  "block.minecraft.oak_sign": "arwodh dhar",
  "block.minecraft.spruce_sign": "arwodh sprus",
  "block.minecraft.birch_sign": "arwodh vesow",
  "block.minecraft.jungle_sign": "arwodh wylgos",
  "block.minecraft.acacia_sign": "arwodh akasia",
  "block.minecraft.dark_oak_sign": "arwodh dhar tewal",
  "block.minecraft.crimson_sign": "arwodh kogh",
  "block.minecraft.warped_sign": "arwodh koynt",
  "item.minecraft.bucket": "kelorn",
  "item.minecraft.water_bucket": "kelorn dowr",
  "item.minecraft.lava_bucket": "kelorn lava",
  "item.minecraft.minecart": "balgert",
  "item.minecraft.saddle": "diber",
  "item.minecraft.redstone": "ponn menrudh",
  "item.minecraft.snowball": "pel ergh",
  "item.minecraft.oak_boat": "skath dhar",
  "item.minecraft.leather": "ledher",
  "item.minecraft.milk_bucket": "kelorn leth",
  "item.minecraft.pufferfish_bucket": "kelorn hwythpysk",
  "item.minecraft.salmon_bucket": "kelorn eghek",
  "item.minecraft.cod_bucket": "kelorn barvus",
  "item.minecraft.tropical_fish_bucket": "kelorn pysk trovannel",
  "item.minecraft.brick": "bryck",
  "item.minecraft.clay_ball": "pel bri",
  "block.minecraft.dried_kelp_block": "stock gommon seghys",
  "item.minecraft.paper": "paper",
  "item.minecraft.book": "lyver",
  "item.minecraft.slime_ball": "slimbel",
  "item.minecraft.chest_minecart": "balgert gans argh",
  "item.minecraft.furnace_minecart": "balkert gans fog",
  "item.minecraft.egg": "oy",
  "item.minecraft.compass": "mornaswydh",
  "item.minecraft.fishing_rod": "gwelen-byskessa",
  "item.minecraft.clock": "klock",
  "item.minecraft.glowstone_dust": "ponn men splann",
  "item.minecraft.cod": "barvus kriv",
  "item.minecraft.salmon": "eghek kriv",
  "item.minecraft.tropical_fish": "pysk trovannel",
  "item.minecraft.pufferfish": "hwythpysk",
  "item.minecraft.cooked_cod": "barvus keginys",
  "item.minecraft.cooked_salmon": "eghek keginys",
  "item.minecraft.ink_sac": "sagh ynk",
  "item.minecraft.red_dye": "liw rudh",
  "item.minecraft.green_dye": "liw gwyrdh",
  "item.minecraft.cocoa_beans": "fav kokoa",
  "item.minecraft.lapis_lazuli": "lapis",
  "item.minecraft.purple_dye": "liw purpur",
  "item.minecraft.cyan_dye": "liw glaswyrdh",
  "item.minecraft.light_gray_dye": "liw gwynnloos",
  "item.minecraft.gray_dye": "liw loos",
  "item.minecraft.pink_dye": "liw rudhwynn",
  "item.minecraft.lime_dye": "liw gwynnwyrdh",
  "item.minecraft.yellow_dye": "liw melyn",
  "item.minecraft.light_blue_dye": "liw glaswynn",
  "item.minecraft.magenta_dye": "liw majenta",
  "item.minecraft.orange_dye": "liw rudhvelyn",
  "item.minecraft.bone_meal": "ponn askorn",
  "item.minecraft.blue_dye": "liw glas",
  "item.minecraft.brown_dye": "liw gell",
  "item.minecraft.black_dye": "liw du",
  "item.minecraft.white_dye": "liw gwynn",
  "item.minecraft.bone": "askorn",
  "item.minecraft.sugar": "sugra",
  "block.minecraft.cake": "tesen",
  "block.minecraft.white_bed": "gweli gwynn",
  "block.minecraft.orange_bed": "gweli rudhvelyn",
  "block.minecraft.magenta_bed": "gweli majenta",
  "block.minecraft.light_blue_bed": "gweli glaswynn",
  "block.minecraft.yellow_bed": "gweli melyn",
  "block.minecraft.lime_bed": "gweli gwynnwyrdh",
  "block.minecraft.pink_bed": "gweli gwynnrudh",
  "block.minecraft.gray_bed": "gweli loos",
  "block.minecraft.light_gray_bed": "gweli gwynnloos",
  "block.minecraft.cyan_bed": "gweli glaswyrdh",
  "block.minecraft.purple_bed": "gweli purpur",
  "block.minecraft.blue_bed": "gweli glas",
  "block.minecraft.brown_bed": "gweli gell",
  "block.minecraft.green_bed": "gweli gwyrdh",
  "block.minecraft.red_bed": "gweli rudh",
  "block.minecraft.black_bed": "gweli du",
  "item.minecraft.cookie": "tesen gales",
  "item.minecraft.filled_map": "mappa□#0",
  "item.minecraft.shears": "gwelsow",
  "item.minecraft.melon_slice": "tregh pompyon hweg",
  "item.minecraft.dried_kelp": "gommon seghys",
  "item.minecraft.pumpkin_seeds": "has pompyon",
  "item.minecraft.melon_seeds": "has pompyon hweg",
  "item.minecraft.beef": "kig bewin kriv",
  "item.minecraft.cooked_beef": "tregh kig",
  "item.minecraft.chicken": "kig yar kriv",
  "item.minecraft.cooked_chicken": "kig yar keginys",
  "item.minecraft.rotten_flesh": "kig poder",
  "item.minecraft.ender_pearl": "perl an diwedh",
  "item.minecraft.blaze_rod": "gwelen dan",
  "item.minecraft.ghast_tear": "dager tarosvan",
  "item.minecraft.gold_nugget": "tamm owr",
  "item.minecraft.nether_wart": "losowen an yfarn",
  "item.minecraft.potion": "ismegen ankreftyadow□heb effeythyow",
  "item.minecraft.glass_bottle": "botel gweder",
  "item.minecraft.spider_eye": "lagas kevnisen",
  "item.minecraft.fermented_spider_eye": "lagas kevnisen fermentys",
  "item.minecraft.blaze_powder": "ponn tan",
  "item.minecraft.magma_cream": "dehen magma",
  "block.minecraft.brewing_stand": "sav braga",
  "block.minecraft.cauldron": "chek",
  "item.minecraft.ender_eye": "lagas den an diwedh",
  "item.minecraft.glistering_melon_slice": "tregh pompyon hweg splann",
  "item.minecraft.bat_spawn_egg": "oy bewhe askel groghen",
  "item.minecraft.bee_spawn_egg": "oy bewhe gwenenen",
  "item.minecraft.blaze_spawn_egg": "oy bewhe tarosvan tan",
  "item.minecraft.cat_spawn_egg": "oy bewhe kath",
  "item.minecraft.cave_spider_spawn_egg": "oy bewhe kevnisen gav",
  "item.minecraft.chicken_spawn_egg": "oy bewhe yar",
  "item.minecraft.cod_spawn_egg": "oy bewhe barvus",
  "item.minecraft.cow_spawn_egg": "oy bewhe bugh",
  "item.minecraft.creeper_spawn_egg": "oy bewhe kreeper",
  "item.minecraft.dolphin_spawn_egg": "oy bewhe pyffyer",
  "item.minecraft.donkey_spawn_egg": "oy bewhe asen",
  "item.minecraft.drowned_spawn_egg": "oy bewhe zombi beudhys",
  "item.minecraft.elder_guardian_spawn_egg": "oy bewhe gwithyas koth",
  "item.minecraft.enderman_spawn_egg": "oy bewhe den an diwedh",
  "item.minecraft.endermite_spawn_egg": "oy bewhe endermite",
  "item.minecraft.evoker_spawn_egg": "oy bewhe sordyer",
  "item.minecraft.fox_spawn_egg": "oy bewhe lowarn",
  "item.minecraft.ghast_spawn_egg": "oy bewhe tarosvan",
  "item.minecraft.guardian_spawn_egg": "oy bewhe gwithyas",
  "item.minecraft.hoglin_spawn_egg": "oy bewhe hoglin",
  "item.minecraft.horse_spawn_egg": "oy bewhe margh",
  "item.minecraft.husk_spawn_egg": "oy bewhe krogen wag",
  "item.minecraft.llama_spawn_egg": "oy bewhe llama",
  "item.minecraft.magma_cube_spawn_egg": "oy bewhe kub lava",
  "item.minecraft.mooshroom_spawn_egg": "oy bewhe bughshroom",
  "item.minecraft.mule_spawn_egg": "oy bewhe mul",
  "item.minecraft.ocelot_spawn_egg": "oy bewhe kath wyls",
  "item.minecraft.panda_spawn_egg": "oy bewhe panda",
  "item.minecraft.parrot_spawn_egg": "oy bewhe papynjay",
  "item.minecraft.phantom_spawn_egg": "oy bewhe fantom",
  "item.minecraft.pig_spawn_egg": "oy bewhe hogh",
  "item.minecraft.piglin_spawn_egg": "oy bewhe piglin",
  "item.minecraft.pillager_spawn_egg": "oy bewhe preydhesik",
  "item.minecraft.polar_bear_spawn_egg": "oy bewhe ors gwynn",
  "item.minecraft.pufferfish_spawn_egg": "oy bewhe hwythpysk",
  "item.minecraft.rabbit_spawn_egg": "oy bewhe konin",
  "item.minecraft.ravager_spawn_egg": "oy bewhe defolyer",
  "item.minecraft.salmon_spawn_egg": "oy bewhe eghek",
  "item.minecraft.sheep_spawn_egg": "oy bewhe davas",
  "item.minecraft.shulker_spawn_egg": "oy bewhe shulker",
  "item.minecraft.silverfish_spawn_egg": "oy bewhe pysk arghans",
  "item.minecraft.skeleton_spawn_egg": "oy bewhe korf eskern",
  "item.minecraft.skeleton_horse_spawn_egg": "oy bewhe margh eskern",
  "item.minecraft.slime_spawn_egg": "oy bewhe slim",
  "item.minecraft.spider_spawn_egg": "oy bewhe kevnisen",
  "item.minecraft.squid_spawn_egg": "oy bewhe stifek",
  "item.minecraft.stray_spawn_egg": "oy bewhe kellys",
  "item.minecraft.strider_spawn_egg": "oy bewhe hirgammer",
  "item.minecraft.trader_llama_spawn_egg": "oy bewhe llama gwikor",
  "item.minecraft.tropical_fish_spawn_egg": "oy bewhe pysk trovannel",
  "item.minecraft.turtle_spawn_egg": "oy bewhe morgroban",
  "item.minecraft.vex_spawn_egg": "oy bewhe molleth",
  "item.minecraft.villager_spawn_egg": "oy bewhe trevesik",
  "item.minecraft.vindicator_spawn_egg": "oy bewhe venjyanser",
  "item.minecraft.wandering_trader_spawn_egg": "oy bewhe gwikor gwandrek",
  "item.minecraft.witch_spawn_egg": "oy bewhe gwragh",
  "item.minecraft.wither_skeleton_spawn_egg": "oy bewhe korf eskern wither",
  "item.minecraft.wolf_spawn_egg": "oy bewhe bleydh",
  "item.minecraft.zoglin_spawn_egg": "oy bewhe zoglin",
  "item.minecraft.zombie_spawn_egg": "oy bewhe zombi",
  "item.minecraft.zombie_horse_spawn_egg": "oy bewhe margh zombi",
  "item.minecraft.zombie_villager_spawn_egg": "oy bewhe trevesik zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "oy bewhe piglin zombi",
  "item.minecraft.experience_bottle": "botel a hus",
  "item.minecraft.fire_charge": "diskargans tan",
  "item.minecraft.writable_book": "lyver ha pluven",
  "item.minecraft.written_book": "lyver skrifys",
  "item.minecraft.emerald": "gwerem",
  "item.minecraft.item_frame": "fram",
  "block.minecraft.flower_pot": "pott",
  "item.minecraft.carrot": "karetysen",
  "item.minecraft.potato": "aval dor",
  "item.minecraft.baked_potato": "aval dor pebys",
  "item.minecraft.poisonous_potato": "aval dor gwenonek",
  "item.minecraft.map": "mappa gwag",
  "item.minecraft.golden_carrot": "karetysen owr",
  "block.minecraft.skeleton_skull": "klopen",
  "block.minecraft.wither_skeleton_skull": "klopen wither",
  "block.minecraft.player_head": "penn gwarier",
  "block.minecraft.zombie_head": "penn zombi",
  "block.minecraft.creeper_head": "penn kreeper",
  "block.minecraft.dragon_head": "penn dragon",
  "item.minecraft.carrot_on_a_stick": "karetysen war gwelen",
  "item.minecraft.warped_fungus_on_a_stick": "fong koynt war welen",
  "item.minecraft.nether_star": "steren nether",
  "item.minecraft.pumpkin_pie": "hogen bompyon",
  "item.minecraft.firework_rocket": "fusen danweythen",
  "item.minecraft.firework_star": "steren tanweyth",
  "item.minecraft.enchanted_book": "lyver gans hus",
  "item.minecraft.nether_brick": "bryckys nether",
  "item.minecraft.quartz": "kanndir nether",
  "item.minecraft.tnt_minecart": "balgert gans dynamit",
  "item.minecraft.hopper_minecart": "balgert gans korn denewi",
  "item.minecraft.prismarine_shard": "tamm prismarin",
  "item.minecraft.prismarine_crystals": "gwrysow prismarin",
  "item.minecraft.rabbit": "kig konin kriv",
  "item.minecraft.cooked_rabbit": "kig konin keginys",
  "item.minecraft.rabbit_stew": "kowl gonin",
  "item.minecraft.rabbit_foot": "troos konin",
  "item.minecraft.rabbit_hide": "kroghen gonin",
  "item.minecraft.armor_stand": "stand arvwisk",
  "item.minecraft.iron_horse_armor": "arwisk margh horn",
  "item.minecraft.golden_horse_armor": "arvwisk margh owr",
  "item.minecraft.diamond_horse_armor": "arvwisk margh adamant",
  "item.minecraft.leather_horse_armor": "arvwisk margh ledher",
  "item.minecraft.lead": "lesh",
  "item.minecraft.name_tag": "tagg hanow",
  "item.minecraft.command_block_minecart": "balgert gans stock gorhemmyn",
  "item.minecraft.mutton": "kig mols kriv",
  "item.minecraft.cooked_mutton": "kig mols keginys",
  "block.minecraft.white_banner": "baner gwynn",
  "block.minecraft.orange_banner": "baner rudhvelyn",
  "block.minecraft.magenta_banner": "baner majenta",
  "block.minecraft.light_blue_banner": "baner glaswynn",
  "block.minecraft.yellow_banner": "baner melyn",
  "block.minecraft.lime_banner": "baner gwyrdhwynn",
  "block.minecraft.pink_banner": "baner rudhwynn",
  "block.minecraft.gray_banner": "baner loos",
  "block.minecraft.light_gray_banner": "baner gwynnloos",
  "block.minecraft.cyan_banner": "baner glaswyrdh",
  "block.minecraft.purple_banner": "baner purpur",
  "block.minecraft.blue_banner": "baner glas",
  "block.minecraft.brown_banner": "baner gell",
  "block.minecraft.green_banner": "baner gwyrdh",
  "block.minecraft.red_banner": "baner rudh",
  "block.minecraft.black_banner": "baner du",
  "item.minecraft.end_crystal": "gwrys an diwedh",
  "item.minecraft.chorus_fruit": "frothen goros",
  "item.minecraft.popped_chorus_fruit": "frothen goros poppys",
  "item.minecraft.beetroot": "betysen rudh",
  "item.minecraft.beetroot_seeds": "has betys rudh",
  "item.minecraft.beetroot_soup": "kowl betys",
  "item.minecraft.dragon_breath": "anal an dhragon",
  "item.minecraft.splash_potion": "ismegen lagyek ankreftyadow□heb effeythyow",
  "item.minecraft.spectral_arrow": "seth tarosvannus",
  "item.minecraft.tipped_arrow": "seth gans bleyn ankreftyadow□heb effeythyow",
  "item.minecraft.lingering_potion": "ismegen dhidorr ankreftyadow□heb effeythyow",
  "item.minecraft.shield": "skoos",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "skath sprus",
  "item.minecraft.birch_boat": "skath vesow",
  "item.minecraft.jungle_boat": "skath wylgos",
  "item.minecraft.acacia_boat": "skath akasia",
  "item.minecraft.dark_oak_boat": "skath dhar tewal",
  "item.minecraft.totem_of_undying": "ikon dasserghyans",
  "item.minecraft.shulker_shell": "krogen shulker",
  "item.minecraft.iron_nugget": "tamm horn",
  "item.minecraft.knowledge_book": "lyver skians",
  "item.minecraft.debug_stick": "gwelen dhibryv",
  "item.minecraft.music_disc_13": "plasen ilow□c418 - 13",
  "item.minecraft.music_disc_cat": "plasen ilow□c418 - cat",
  "item.minecraft.music_disc_blocks": "plasen ilow□c418 - blocks",
  "item.minecraft.music_disc_chirp": "plasen ilow□c418 - chirp",
  "item.minecraft.music_disc_far": "plasen ilow□c418 - far",
  "item.minecraft.music_disc_mall": "plasen ilow□c418 - mall",
  "item.minecraft.music_disc_mellohi": "plasen ilow□c418 - mellohi",
  "item.minecraft.music_disc_stal": "plasen ilow□c418 - stal",
  "item.minecraft.music_disc_strad": "plasen ilow□c418 - strad",
  "item.minecraft.music_disc_ward": "plasen ilow□c418 - ward",
  "item.minecraft.music_disc_11": "plasen ilow□c418 - 11",
  "item.minecraft.music_disc_wait": "plasen ilow□c418 - wait",
  "item.minecraft.music_disc_pigstep": "plasen ilow□lena raine - pigstep",
  "item.minecraft.trident": "tryforgh□□yn leuv jyf:□+8 kisyans omsettyans□-2.9 skavder omsettyer",
  "item.minecraft.phantom_membrane": "kennen fantom",
  "item.minecraft.nautilus_shell": "krogen nautilus",
  "item.minecraft.heart_of_the_sea": "kolon an mor",
  "item.minecraft.crossbow": "fustwarak",
  "item.minecraft.suspicious_stew": "kowl skeusek",
  "block.minecraft.loom": "starn gwiader",
  "item.minecraft.flower_banner_pattern": "patron baner□arwodh bleujen",
  "item.minecraft.creeper_banner_pattern": "patron baner□arwodh kreeper",
  "item.minecraft.skull_banner_pattern": "patron baner□arwodh klopen",
  "item.minecraft.mojang_banner_pattern": "patron baner□pyth",
  "item.minecraft.globe_banner_pattern": "patron baner□pel an norvys",
  "item.minecraft.piglin_banner_pattern": "patron baner□tron",
  "block.minecraft.composter": "teylell",
  "block.minecraft.barrel": "balyer",
  "block.minecraft.smoker": "megell",
  "block.minecraft.blast_furnace": "fog hwyth",
  "block.minecraft.cartography_table": "moos vappa",
  "block.minecraft.fletching_table": "moos sethweyth",
  "block.minecraft.grindstone": "men mala",
  "block.minecraft.lectern": "lennva",
  "block.minecraft.smithing_table": "moos gov",
  "block.minecraft.stonecutter": "treghell ven",
  "block.minecraft.bell": "klogh",
  "block.minecraft.lantern": "lugarn",
  "block.minecraft.soul_lantern": "lugarn enev",
  "item.minecraft.sweet_berries": "moren hweg",
  "block.minecraft.campfire": "tan kamp",
  "block.minecraft.soul_campfire": "tan kamp enev",
  "block.minecraft.shroomlight": "golow-shroom",
  "item.minecraft.honeycomb": "kriben vel",
  "block.minecraft.bee_nest": "neyth gwenen",
  "block.minecraft.beehive": "kowel gwenen",
  "item.minecraft.honey_bottle": "botel mel",
  "block.minecraft.honey_block": "stock mel",
  "block.minecraft.honeycomb_block": "stock kriben vel",
  "block.minecraft.lodestone": "tenven",
  "block.minecraft.netherite_block": "stock netherit",
  "block.minecraft.ancient_debris": "hen atal",
  "block.minecraft.target": "kosten",
  "block.minecraft.crying_obsidian": "obsydyann ola",
  "block.minecraft.blackstone": "men du",
  "block.minecraft.blackstone_slab": "leghen vendhu",
  "block.minecraft.blackstone_stairs": "grisyow mendhu",
  "block.minecraft.gilded_blackstone": "men du owrek",
  "block.minecraft.polished_blackstone": "men du polsys",
  "block.minecraft.polished_blackstone_slab": "leghen vendhu polsys",
  "block.minecraft.polished_blackstone_stairs": "grisyow men du polsys",
  "block.minecraft.chiseled_polished_blackstone": "mendhu polsys kervys",
  "block.minecraft.polished_blackstone_bricks": "bryckys men du polsys",
  "block.minecraft.polished_blackstone_brick_slab": "leghen vryck men du polsys",
  "block.minecraft.polished_blackstone_brick_stairs": "grisyow bryck men du polsys",
  "block.minecraft.cracked_polished_blackstone_bricks": "bryckys men du polsys krackys",
  "block.minecraft.respawn_anchor": "ankor dasserghi",
}
export const kw_gb = items; 
